import types from 'helpers/constants';

export const initializeMenuPlanners = settings => dispatch =>
  dispatch({
    type: types.INITIALIZE_MENU_PLANNERS,
    payload: {
      ...settings,
    },
  });

export const updateVisibleVariants = (newVariants, brandIri) => dispatch =>
  dispatch({
    type: types.UPDATE_VISIBLE_VARIANTS,
    payload: {
      brandIri,
      visibleVariants: newVariants,
    },
  });

export const updateVisibleDiets = (newDiets, brandIri) => dispatch =>
  dispatch({
    type: types.UPDATE_VISIBLE_DIETS,
    payload: {
      brandIri,
      visibleDiets: newDiets,
    },
  });
